// FAQ de /faq — contenido fuente: FAQ_EOS_Carlos_Garcin_v2.docx.
// Sintaxis en respuestas: [texto](/ruta) = enlace interno; **texto** = negrita. `cta` = invitación a /contacto bajo la respuesta.

export const FAQ_CATEGORIES = [
  {
    "id": "que-es-eos",
    "title": "¿Qué es EOS?",
    "short": "¿Qué es EOS?",
    "icon": "CircleHelp",
    "items": [
      {
        "id": "que-es-eos",
        "q": "¿Qué es EOS?",
        "a": [
          "EOS® — Entrepreneurial Operating System® es un **sistema operativo completo y probado** para empresas emprendedoras.",
          "Ayuda a los equipos de liderazgo a lograr tres cosas: tener una **Visión clara y compartida**, generar **Tracción mediante disciplina y ejecución**, y convertirse en un equipo más **Saludable, cohesionado y funcional**.",
          "EOS se basa en herramientas simples y prácticas que ayudan a gestionar la empresa de una forma más clara, consistente y efectiva."
        ]
      },
      {
        "id": "que-significa-eos",
        "q": "¿Qué significa EOS?",
        "a": [
          "EOS significa **Entrepreneurial Operating System**.",
          "Es el nombre de un **sistema específico** creado por [Gino Wickman](/historia-eos), **no un término genérico** para referirse a cualquier sistema de gestión empresarial."
        ]
      },
      {
        "id": "quien-creo-eos",
        "q": "¿Quién creó EOS?",
        "a": [
          "EOS fue creado por [Gino Wickman](/historia-eos) **a comienzos de los años 2000**.",
          "En 2007 publicó [Traction: Get a Grip on Your Business](/libros-eos), libro en el que presentó EOS al mercado. Posteriormente, en 2008, **cofundó EOS Worldwide junto a Don Tinney**."
        ]
      },
      {
        "id": "que-es-el-modelo-eos",
        "q": "¿Qué es el Modelo EOS®?",
        "a": [
          "El Modelo EOS® representa los [Seis Componentes Clave](/el-modelo-eos)® presentes en cualquier empresa: **Visión, Personas, Datos, Asuntos, Procesos y Tracción**.",
          "EOS ayuda a **fortalecer sistemáticamente estos seis componentes** para construir una organización más sólida, alineada y capaz de ejecutar."
        ]
      },
      {
        "id": "eos-es-una-metodologia",
        "q": "¿EOS es una metodología?",
        "a": [
          "EOS es más que una metodología: es **un sistema operativo completo para gestionar una empresa**.",
          "No entrega únicamente conceptos o recomendaciones. Proporciona **herramientas concretas, disciplinas y una forma consistente de operar el negocio**."
        ]
      }
    ]
  },
  {
    "id": "herramientas",
    "title": "Las herramientas de EOS",
    "short": "Herramientas",
    "icon": "Wrench",
    "items": [
      {
        "id": "que-es-el-v-to",
        "q": "¿Qué es el V/TO®?",
        "a": [
          "El V/TO® — Vision/[Traction](/libros-eos) Organizer® es un **documento de dos páginas** que permite capturar de manera simple **la Visión de la organización y su plan para ejecutarla**.",
          "Ayuda al equipo de liderazgo a ponerse de acuerdo sobre **hacia dónde va la empresa, cómo llegará allí y cuáles son sus principales prioridades**."
        ]
      },
      {
        "id": "que-son-las-rocas",
        "q": "¿Qué son las Rocas?",
        "a": [
          "Las Rocas son las **prioridades más importantes** que una empresa, equipo o persona debe completar durante los **próximos 90 días**.",
          "La idea es **evitar tener demasiadas prioridades simultáneamente** y concentrar la energía en aquello que realmente debe suceder durante el trimestre."
        ]
      },
      {
        "id": "que-es-una-reunion-de-nivel-10",
        "q": "¿Qué es una Reunión de Nivel 10™?",
        "a": [
          "La [Reunión de Nivel 10™](/reuniones-largas-sin-resultados) es la reunión semanal utilizada por los equipos que operan con EOS.",
          "**Dura 90 minutos**, se realiza el mismo día y a la misma hora todas las semanas y sigue siempre la **misma agenda**.",
          "Su objetivo es mantener al equipo **alineado, enfocado, responsable por sus compromisos** y resolviendo los Asuntos que realmente están frenando a la organización."
        ]
      },
      {
        "id": "que-es-ids",
        "q": "¿Qué es IDS®?",
        "a": [
          "IDS® significa **Identify, Discuss, Solve**: Identificar, Discutir y Resolver.",
          "Es el proceso que utiliza EOS para resolver los Asuntos **desde su causa raíz**, **en lugar de quedarse trabajando permanentemente sobre sus síntomas**."
        ]
      },
      {
        "id": "que-es-el-tablero-de-indicadores",
        "q": "¿Qué es el Tablero de Indicadores?",
        "a": [
          "El [Tablero de Indicadores](/como-construir-un-tablero-de-indicadores) es un conjunto reducido de métricas que permite tener semanalmente un **pulso objetivo del negocio**.",
          "Normalmente contiene **entre 5 y 15 indicadores**, cada uno con **un responsable y una meta**, permitiendo detectar rápidamente aquello que está saliéndose de lo esperado."
        ]
      },
      {
        "id": "que-es-el-accountability-chart-o-diagrama-de-rendicion-de-cuentas",
        "q": "¿Qué es el Accountability Chart o Diagrama de Rendición de Cuentas?",
        "a": [
          "El [Accountability Chart](/organizacion-correcta-antes-de-completar-el-equipo) **define la estructura que necesita la empresa para alcanzar su Visión**.",
          "A diferencia de un organigrama tradicional, EOS comienza definiendo **primero cuáles son los puestos, funciones y responsabilidades** que la organización necesita y **luego determina qué persona debe ocupar cada puesto**.",
          "El objetivo es lograr tener [Personas Correctas en los Puestos Correctos](/persona-correcta-puesto-correcto)."
        ]
      },
      {
        "id": "que-significa-gwc",
        "q": "¿Qué significa GWC®?",
        "a": [
          "GWC® corresponde a **Get it, Want it, Capacity to do it**.",
          "EOS utiliza estas tres preguntas para determinar si una persona está realmente en el Puesto Correcto: **¿Lo entiende? ¿Lo quiere? ¿Tiene la capacidad para hacerlo?**",
          "**Las tres respuestas deben ser afirmativas**."
        ]
      },
      {
        "id": "que-es-el-enfoque-medular-o-central",
        "q": "¿Qué es el Enfoque Medular o Central?",
        "a": [
          "El Enfoque Medular ayuda a una empresa a definir claramente **por qué existe** y **aquello que hace especialmente bien**.",
          "Combina dos elementos: **su propósito, causa o pasión y su nicho**.",
          "Tener claridad sobre el Enfoque Central permite concentrar los recursos y **evitar distracciones** que alejen a la organización de aquello en lo que realmente debe enfocarse."
        ]
      },
      {
        "id": "que-son-los-valores-fundamentales",
        "q": "¿Qué son los Valores Fundamentales?",
        "a": [
          "Los Valores Fundamentales son los **principios esenciales y permanentes que definen la cultura** de una organización.",
          "También ayudan a determinar **quiénes son las Personas Correctas para la empresa** y sirven como referencia para contratar, evaluar, reconocer, desarrollar y tomar decisiones respecto de las personas."
        ]
      },
      {
        "id": "que-es-una-pausa-de-claridad",
        "q": "¿Qué es una Pausa de Claridad™?",
        "a": [
          "Una Pausa de Claridad™ es un **espacio reservado deliberadamente para alejarse de la operación y pensar**.",
          "Es tiempo **sin reuniones, teléfono ni interrupciones**, dedicado a reflexionar, planificar y **trabajar sobre la empresa, en lugar de estar permanentemente trabajando dentro de ella**."
        ]
      }
    ]
  },
  {
    "id": "implementacion",
    "title": "Implementación de EOS",
    "short": "Implementación",
    "icon": "Route",
    "items": [
      {
        "id": "como-se-implementa-eos",
        "q": "¿Cómo se implementa EOS?",
        "a": [
          "La implementación se realiza **junto al equipo de liderazgo** siguiendo el [Proceso EOS®](/implementacion), **incorporando progresivamente las herramientas y disciplinas necesarias** para fortalecer los [Seis Componentes Clave](/el-modelo-eos) de la organización.",
          "Como [Implementador Profesional de EOS](/implementador-eos), mi rol es **enseñar las herramientas, facilitar las conversaciones y acompañar al equipo** durante este proceso hasta que llegue a dominarlas y pueda **ejecutar EOS por sí mismo**."
        ],
        "cta": "Conversemos sobre cómo sería en tu empresa"
      },
      {
        "id": "para-que-tamano-de-empresa-funciona-mejor-eos",
        "q": "¿Para qué tamaño de empresa funciona mejor EOS?",
        "a": [
          "EOS está especialmente diseñado para empresas emprendedoras y su rango típico es de aproximadamente **10 a 250 personas**.",
          "Más que el tamaño exacto, es importante que exista **un equipo de liderazgo dispuesto a crecer, enfrentar abiertamente sus problemas y trabajar con disciplina** para llevar la organización al siguiente nivel."
        ],
        "cta": "Cuéntame de tu empresa y vemos si EOS hace sentido"
      },
      {
        "id": "cual-es-el-primer-paso-para-implementar-eos",
        "q": "¿Cuál es el primer paso para implementar EOS?",
        "a": [
          "El primer paso es una [Reunión de 90 Minutos](/contacto).",
          "Es una **sesión sin costo** en la que me reúno contigo y con tu equipo de liderazgo para conocer su empresa y sus principales desafíos, explicarles qué es EOS, mostrarles sus herramientas y enseñarles cómo funciona el proceso completo de implementación.",
          "Al terminar, tendrán **toda la información necesaria para decidir si EOS hace sentido para su empresa**."
        ],
        "cta": "Agenda tu Reunión de 90 Minutos sin costo"
      }
    ]
  },
  {
    "id": "implementadores",
    "title": "Implementadores Profesionales de EOS",
    "short": "Implementadores",
    "icon": "UserCheck",
    "items": [
      {
        "id": "que-es-un-implementador-profesional-de-eos",
        "q": "¿Qué es un Implementador Profesional de EOS?",
        "a": [
          "Un [Implementador Profesional de EOS](/implementador-eos) es un profesional **entrenado por EOS Worldwide** para **enseñar, facilitar y acompañar** a los equipos de liderazgo durante el [Proceso EOS®](/implementacion).",
          "Como Implementador, mi trabajo **no es llegar a decirte cómo administrar tu empresa**. Mi rol es **enseñarte un sistema probado**, facilitar las conversaciones que tu equipo necesita tener y ayudarlos a dominar las herramientas necesarias para gestionar mejor la organización."
        ],
        "cta": "Conversemos sobre EOS, sin compromiso"
      },
      {
        "id": "como-puedo-trabajar-con-un-implementador-de-eos",
        "q": "¿Cómo puedo trabajar con un Implementador de EOS?",
        "a": [
          "Si tu empresa está en Chile o Latinoamérica, podemos comenzar con una [Reunión de 90 Minutos](/contacto) **sin costo** junto a tu equipo de liderazgo.",
          "Durante esa reunión conocerán EOS, revisaremos los principales desafíos de su empresa, veremos sus herramientas y les explicaré **exactamente cómo sería el proceso de implementación**.",
          "La reunión no implica **ningún compromiso posterior**."
        ],
        "cta": "Agenda una conversación conmigo"
      },
      {
        "id": "cual-es-la-diferencia-entre-un-implementador-de-eos-y-un-coach-empresarial",
        "q": "¿Cuál es la diferencia entre un Implementador de EOS y un coach empresarial?",
        "a": [
          "Un coach empresarial puede utilizar distintos modelos, metodologías y aproximaciones dependiendo de su experiencia.",
          "Como Implementador Profesional de EOS, trabajo con **un sistema específico y probado**. Enseño las herramientas, facilito su implementación y acompaño al equipo de liderazgo siguiendo un proceso claramente definido.",
          "Además, existe un objetivo final muy concreto: **que el equipo domine EOS y pueda continuar utilizándolo sin depender permanentemente de mí**."
        ],
        "cta": "¿Dudas entre un coach y un Implementador? Conversemos"
      },
      {
        "id": "el-implementador-de-eos-permanece-para-siempre-trabajando-con-la-empresa",
        "q": "¿El Implementador de EOS permanece para siempre trabajando con la empresa?",
        "a": [
          "**No.** La implementación **tiene un principio y un final**.",
          "Normalmente trabajo con una organización **hasta que el equipo de liderazgo domina las herramientas** y está preparado para continuar ejecutando EOS por sí mismo."
        ]
      },
      {
        "id": "los-implementadores-de-eos-son-empleados-de-eos-worldwide",
        "q": "¿Los Implementadores de EOS son empleados de EOS Worldwide?",
        "a": [
          "**No.**",
          "Los Implementadores Profesionales de EOS son **profesionales independientes, emprendedores**, **entrenados por EOS Worldwide** y responsables de desarrollar sus propias prácticas siguiendo los principios y estándares de EOS."
        ]
      }
    ]
  },
  {
    "id": "reuniones",
    "title": "Reuniones EOS",
    "short": "Reuniones",
    "icon": "CalendarClock",
    "items": [
      {
        "id": "cuanto-dura-una-reunion-de-nivel-10",
        "q": "¿Cuánto dura una Reunión de Nivel 10™?",
        "a": [
          "**90 minutos.**",
          "Se realiza **semanalmente, el mismo día, a la misma hora** y siguiendo siempre la misma agenda."
        ]
      },
      {
        "id": "por-que-se-llama-reunion-de-nivel-10",
        "q": "¿Por qué se llama Reunión de Nivel 10?",
        "a": [
          "Porque al terminar la reunión **cada participante la califica de 1 a 10**.",
          "El objetivo es acercarse consistentemente a una reunión de nivel 10. Cuando la evaluación está **por debajo de 8, el equipo identifica qué necesita mejorar**."
        ]
      },
      {
        "id": "que-es-el-pulso-de-reuniones",
        "q": "¿Qué es el Pulso de Reuniones®?",
        "a": [
          "El Pulso de Reuniones® es la **cadencia de reuniones que mantiene sincronizado al equipo de liderazgo**.",
          "Incluye las **Reuniones de Nivel 10 semanales, las sesiones trimestrales y la planificación anual**.",
          "Cada una tiene un objetivo y una frecuencia específica, creando un **ritmo constante de comunicación, planificación y ejecución**."
        ]
      }
    ]
  },
  {
    "id": "personas-y-roles",
    "title": "Personas y roles en EOS",
    "short": "Personas y roles",
    "icon": "Users",
    "items": [
      {
        "id": "que-es-un-visionario-en-eos",
        "q": "¿Qué es un Visionario en EOS?",
        "a": [
          "El Visionario suele ser el **fundador, dueño o uno de los principales líderes** de la organización.",
          "Normalmente tiene una gran capacidad para **generar ideas, visualizar oportunidades**, desarrollar relaciones importantes, impulsar la cultura y pensar hacia dónde debería avanzar la empresa.",
          "Suele sentirse más cómodo trabajando sobre **grandes ideas y desafíos estratégicos** que gestionando todos los detalles de la operación diaria."
        ]
      },
      {
        "id": "que-es-un-integrador-en-eos",
        "q": "¿Qué es un Integrador en EOS?",
        "a": [
          "El Integrador es quien **conecta y coordina las principales funciones de la organización**, ayudando a **convertir la Visión en ejecución**.",
          "Asegura que las distintas áreas trabajen de manera integrada, mantiene al equipo alineado y ayuda a generar la **disciplina necesaria para que las prioridades acordadas realmente sucedan**."
        ]
      },
      {
        "id": "que-significa-persona-correcta-en-el-puesto-correcto",
        "q": "¿Qué significa Persona Correcta en el Puesto Correcto?",
        "a": [
          "EOS utiliza **dos criterios diferentes**:",
          "Una Persona Correcta es alguien que **representa y vive los Valores Fundamentales** de la organización.",
          "Estar en el Puesto Correcto significa que esa persona cumple con GWC®: **entiende el puesto, quiere hacerlo y tiene la capacidad para desempeñarlo correctamente**.",
          "Para EOS, **ambas condiciones deben cumplirse**."
        ]
      },
      {
        "id": "que-pasa-si-alguien-no-es-la-persona-correcta-en-el-puesto-correcto",
        "q": "¿Qué pasa si alguien no es la Persona Correcta en el Puesto Correcto?",
        "a": [
          "Si alguien es la Persona Correcta, pero está en el puesto equivocado, puede ser necesario **encontrar un puesto que se ajuste mejor a sus capacidades**.",
          "Si la persona no representa los Valores Fundamentales de la organización, el problema es distinto y debe abordarse directamente como un **Asunto de Personas**.",
          "El objetivo es construir una organización en la que las **Personas Correctas estén ocupando los Puestos Correctos**."
        ]
      }
    ]
  },
  {
    "id": "rocas-y-ejecucion",
    "title": "Rocas y ejecución",
    "short": "Rocas y ejecución",
    "icon": "Mountain",
    "items": [
      {
        "id": "cuantas-rocas-deberia-tener-una-persona",
        "q": "¿Cuántas Rocas debería tener una persona?",
        "a": [
          "Una persona puede tener **entre una y siete Rocas por trimestre**, aunque normalmente tendrá **entre tres y cinco**.",
          "La lógica es mantener pocas prioridades realmente importantes.",
          "**Si todo es prioritario, nada termina siendo prioritario**."
        ]
      },
      {
        "id": "que-ocurre-si-no-se-completa-una-roca",
        "q": "¿Qué ocurre si no se completa una Roca?",
        "a": [
          "Una Roca que no se completa **pasa a convertirse en un Asunto**.",
          "El equipo debe entender qué ocurrió y utilizar IDS® para **identificar la causa real, discutirla y resolverla**."
        ]
      },
      {
        "id": "por-que-las-rocas-se-trabajan-cada-90-dias",
        "q": "¿Por qué las Rocas se trabajan cada 90 días?",
        "a": [
          "EOS trabaja dentro de lo que denomina un **Mundo de 90 Días®**.",
          "Noventa días es un período **suficientemente largo para lograr avances importantes, pero suficientemente corto para mantener foco, urgencia y responsabilidad** sobre los compromisos."
        ]
      },
      {
        "id": "como-debe-ser-una-buena-roca",
        "q": "¿Cómo debe ser una buena Roca?",
        "a": [
          "Una buena Roca debe ser **SMART: Específica, Medible, Alcanzable, Realista y con un plazo definido**.",
          "Además, debe existir **una sola persona responsable** por lograr que esa Roca se complete."
        ]
      }
    ]
  },
  {
    "id": "resultados",
    "title": "Resultados de EOS",
    "short": "Resultados",
    "icon": "TrendingUp",
    "items": [
      {
        "id": "que-resultados-puedo-esperar-al-implementar-eos",
        "q": "¿Qué resultados puedo esperar al implementar EOS?",
        "a": [
          "Al implementar EOS, una empresa debería avanzar hacia una **Visión más clara, mejores decisiones, mayor responsabilidad, mejor ejecución y un equipo de liderazgo más saludable y cohesionado**.",
          "El objetivo es fortalecer sistemáticamente los Seis Componentes Clave de la organización para **que la empresa funcione mejor** y pueda alcanzar sus objetivos de manera más consistente."
        ],
        "cta": "Conversemos sobre qué resultados podrías esperar en tu empresa"
      },
      {
        "id": "eos-realmente-funciona",
        "q": "¿EOS realmente funciona?",
        "a": [
          "**EOS funciona cuando el equipo de liderazgo está dispuesto a hacer el trabajo**.",
          "**No existen herramientas mágicas**. El sistema requiere **apertura, honestidad, disciplina y voluntad** para enfrentar los Asuntos de la organización y cumplir los acuerdos que el equipo va tomando.",
          "Hoy EOS es utilizado por **cientos de miles de empresas alrededor del mundo**."
        ],
        "cta": "Conversa conmigo si quieres saber si funcionaría en tu empresa"
      },
      {
        "id": "cual-es-una-de-las-partes-mas-dificiles-de-implementar-eos",
        "q": "¿Cuál es una de las partes más difíciles de implementar EOS?",
        "a": [
          "**La honestidad.**",
          "EOS genera espacios donde el equipo debe poner sobre la mesa **problemas, desacuerdos y conversaciones que muchas organizaciones han postergado** durante mucho tiempo.",
          "Ser **abiertos, honestos y vulnerables** permite llegar a los Asuntos reales y resolverlos."
        ]
      },
      {
        "id": "cual-es-una-de-las-principales-razones-por-las-que-una-implementacion-de-eos-puede-fracasar",
        "q": "¿Cuál es una de las principales razones por las que una implementación de EOS puede fracasar?",
        "a": [
          "**La falta de compromiso del liderazgo.**",
          "EOS requiere que quienes lideran la organización realmente **adopten las herramientas, respeten el proceso y sostengan los acuerdos** que toman.",
          "**Sin ese compromiso desde arriba**, difícilmente el resto de la organización podrá adoptar el sistema correctamente."
        ]
      }
    ]
  },
  {
    "id": "eos-worldwide",
    "title": "Acerca de EOS Worldwide",
    "short": "EOS Worldwide",
    "icon": "Globe",
    "items": [
      {
        "id": "que-es-eos-worldwide",
        "q": "¿Qué es EOS Worldwide?",
        "a": [
          "EOS Worldwide es la **organización detrás de EOS**® — Entrepreneurial Operating System®.",
          "Fue **cofundada en 2008** por Gino Wickman y Don Tinney y es responsable de **desarrollar, enseñar y licenciar EOS alrededor del mundo**."
        ]
      },
      {
        "id": "quien-lidera-eos-worldwide",
        "q": "¿Quién lidera EOS Worldwide?",
        "a": [
          "**Mark O'Donnell** es actualmente **Visionario y CEO de EOS Worldwide** y lidera la expansión global de EOS."
        ]
      },
      {
        "id": "quien-es-gino-wickman",
        "q": "¿Quién es Gino Wickman?",
        "a": [
          "Gino Wickman es el **creador de EOS** y **cofundador de EOS Worldwide**.",
          "También es autor de Traction y de varios libros relacionados con EOS y el mundo emprendedor, entre ellos Rocket Fuel, How to Be a Great Boss, Get A Grip, What the Heck Is EOS?, The EOS Life y Entrepreneurial Leap."
        ]
      }
    ]
  }
];
